import dayjs from "dayjs";
import { toast } from "react-toastify";
import ReservationSummaryModel from "src/models/ReservationSummaryModel";

export const generateFilters = (startDate, endDate) => {
    if (startDate && !endDate) {
        throw new Error("You should select an end date also.");
    }

    if (!startDate && endDate) {
        throw new Error("You should select a start date also.");
    }

    const filters = [];

    if (startDate && endDate) {
        const formattedStartDate = dayjs(startDate).format("YYYY-MM-DD");
        const formattedEndDate = dayjs(endDate).format("YYYY-MM-DD");
        filters.push(`CreatedDate ge ${formattedStartDate} and CreatedDate le ${formattedEndDate}`);
    }

    return filters.join(" and ");
};


export const handleSearch = async ({ 
    startDate, 
    endDate, 
    dispatch, 
    fetchReservationSummaryList, 
    instance, 
    accounts, 
    setLoading 
}) => {
    setLoading(true);
    try {
        const filter = generateFilters(startDate, endDate);
        await dispatch(
            fetchReservationSummaryList(instance, accounts, {
                filter,
                top: 100,
                orderBy: "CreatedDate desc",
            })
        );
    } catch (error) {
        toast.error(error.message || "An error occurred.");
    } finally {
        setLoading(false);
    }
};

export const convertToSummaries = (results) =>{
    return results.map(i => ({ ...new ReservationSummaryModel(i)}))
}

export const updateGuest = (state, originalGuest, update) => {
    if (state.reservationOverview?.Pax) {
        const guest = state.reservationOverview.Pax.find(p =>
            p.PaxNumber === originalGuest.PaxNumber
        );
        if (guest) {
            update(guest);
            state.isGuestInfoChanged = true;
        }
    }
};
